import { pixelToDxa } from '@/libs/utils/docxUtils'
import {
  AlignmentType,
  PageBreak,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  TextRun,
  VerticalAlign,
  WidthType,
  HeadingLevel,
  TableLayoutType,
} from 'docx'
import SectionHeader from '../../SectionHeader'
import { tableWidthDxa1150 } from '../../constants'

const Cell = ({ children, text = '', textProps = {}, ...props }) =>
  new TableCell({
    margins: { top: 100, bottom: 200, left: 100, right: 100 },
    verticalAlign: VerticalAlign.CENTER,
    children: [
      new Paragraph({
        children: Array.isArray(children) ? children : [new TextRun({ text, ...textProps })], // Ensure children is an array
        alignment: AlignmentType.CENTER,
      }),
    ],
    ...props,
  })

const HeaderCell = ({ textProps, ...props }) =>
  Cell({
    textProps: { ...textProps, bold: true },
    ...props,
  })

const Chapter4Sub2Page = ({ reportData }) => {
  const { tempResults } = reportData || {}

  // const limitedData = tempResults.slice(0, 5) || []

  const formattedData =
    Array.isArray(tempResults) && tempResults.length > 0
      ? tempResults.map(data => {
          const formatPercent = value => {
            if (value != null) {
              return Number(value).toFixed(2) // 強制保留兩位小數
            }
            return '0.00' // 無效值回傳 '0.00'
          }

          // 確保所有的報告數據都有默認值，避免 null 或 undefined
          const formattedReport = {
            userCount: data.report.userCount || 0,
            openCount: data.report.openCount || 0,
            openPercent: formatPercent(data.report.openPercent) ?? 0,
            linkCount: data.report.linkCount || 0,
            linkPercent: formatPercent(data.report.linkPercent) ?? 0,
            fileCount: data.report.fileCount || 0,
            filePercent: formatPercent(data.report.filePercent) ?? 0,
            textCount: data.report.textCount || 0,
            textPercent: formatPercent(data.report.textPercent) ?? 0,
          }

          return new TableRow({
            children: [
              new Cell({
                children: [
                  new TextRun({
                    text: `${data.tempId}`,

                    font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                    size: 20,
                  }),
                ],
                shading: { fill: '#e8ecf2' },
              }),
              new Cell({
                children: [
                  new TextRun({
                    text: `${formattedReport.userCount}`,

                    font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                    size: 20,
                  }),
                ],
                shading: { fill: '#e8ecf2' },
              }),
              new Cell({
                children: [
                  new TextRun({
                    text: `${formattedReport.openCount}`,

                    font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                    size: 20,
                  }),
                ],
                shading: { fill: '#e8ecf2' },
              }),
              new Cell({
                children: [
                  new TextRun({
                    text: `${formattedReport.openPercent}%`,

                    font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                    size: 20,
                  }),
                ],
                shading: { fill: '#e8ecf2' },
              }),
              new Cell({
                children: [
                  new TextRun({
                    text: `${formattedReport.linkCount}`,

                    font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                    size: 20,
                  }),
                ],
                shading: { fill: '#e8ecf2' },
              }),
              new Cell({
                children: [
                  new TextRun({
                    text: `${formattedReport.linkPercent}%`,

                    font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                    size: 20,
                  }),
                ],
                shading: { fill: '#e8ecf2' },
              }),
              new Cell({
                children: [
                  new TextRun({
                    text: `${formattedReport.fileCount}`,

                    font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                    size: 20,
                  }),
                ],
                shading: { fill: '#e8ecf2' },
              }),
              new Cell({
                children: [
                  new TextRun({
                    text: `${formattedReport.filePercent}%`,

                    font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                    size: 20,
                  }),
                ],
                shading: { fill: '#e8ecf2' },
              }),
              new Cell({
                children: [
                  new TextRun({
                    text: `${formattedReport.textCount}`,

                    font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                    size: 20,
                  }),
                ],
                shading: { fill: '#e8ecf2' },
              }),
              new Cell({
                children: [
                  new TextRun({
                    text: `${formattedReport.textPercent}%`,

                    font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                    size: 20,
                  }),
                ],
                shading: { fill: '#e8ecf2' },
              }),
            ],
          })
        })
      : []

  return [
    new Paragraph({ children: [new PageBreak()] }),
    new Paragraph(''),
    SectionHeader({
      text: '4.2 受測者行為依樣版統計',
      size: 48,
      headingNumber: HeadingLevel.HEADING_2,
    }),
    new Paragraph(''),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '\t',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '依照',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '不同類型之範本郵件',
          bold: true,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '統計',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '「瀏覽郵件」、「點閱連結」、「開啟附件」與「輸入資料」',

          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '人數比率。 下表依照',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '樣板與受測人數',
          bold: true,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '統計之',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '「瀏覽郵件」、「點閱連結」、「開啟附件」與「輸入資料」',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '之人數統計報表：',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
    new Paragraph(''),
    new Table({
      indent: { size: pixelToDxa(-50), type: WidthType.DXA },
      layout: TableLayoutType.FIXED,
      // columnWidths: Array(10).fill(tableWidthDxa1150 / 10), // 自動填充 10 個等寬欄位
      columnWidths: [0.08, 0.12, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1].map(
        ratio => tableWidthDxa1150 * ratio,
      ),
      width: { size: tableWidthDxa1150, type: WidthType.DXA },
      rows: [
        // 第一行 - 表頭，顯示受測人數以及每個分類的總稱
        new TableRow({
          children: [
            HeaderCell({
              children: [
                new TextRun({
                  text: '樣板',
                  bold: true,
                  color: '#ffffff',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 20,
                }),
              ],
              shading: { fill: '#4c82bf' },
              rowSpan: 2,
            }),
            HeaderCell({
              children: [
                new TextRun({
                  text: '受測人數',
                  bold: true,
                  color: '#ffffff',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 20,
                }),
              ],
              shading: { fill: '#4c82bf' },
              rowSpan: 2,
            }),
            HeaderCell({
              children: [
                new TextRun({
                  text: '瀏覽信件',
                  bold: true,
                  color: '#ffffff',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 20,
                }),
              ],
              shading: { fill: '#4c82bf' },
              columnSpan: 2,
            }),
            HeaderCell({
              children: [
                new TextRun({
                  text: '點閱連結',
                  bold: true,
                  color: '#ffffff',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 20,
                }),
              ],
              shading: { fill: '#4c82bf' },
              columnSpan: 2,
            }),
            HeaderCell({
              children: [
                new TextRun({
                  text: '開啟附件',
                  bold: true,
                  color: '#ffffff',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 20,
                }),
              ],
              shading: { fill: '#4c82bf' },
              columnSpan: 2,
            }),
            HeaderCell({
              children: [
                new TextRun({
                  text: '輸入資料',
                  bold: true,
                  color: '#ffffff',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 20,
                }),
              ],
              shading: { fill: '#4c82bf' },
              columnSpan: 2,
            }),
          ],
        }),
        // 第二行 - 表頭的第二行，顯示人數和比率欄位
        new TableRow({
          children: [
            HeaderCell({
              children: [
                new TextRun({
                  text: '人數',
                  bold: true,
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 20,
                }),
              ],
              shading: { fill: '#d7e0ed' },
            }),
            HeaderCell({
              children: [
                new TextRun({
                  text: '比率',
                  bold: true,
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 20,
                }),
              ],
              shading: { fill: '#d7e0ed' },
            }),
            HeaderCell({
              children: [
                new TextRun({
                  text: '人數',
                  bold: true,
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 20,
                }),
              ],
              shading: { fill: '#d7e0ed' },
            }),
            HeaderCell({
              children: [
                new TextRun({
                  text: '比率',
                  bold: true,
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 20,
                }),
              ],
              shading: { fill: '#d7e0ed' },
            }),
            HeaderCell({
              children: [
                new TextRun({
                  text: '人數',
                  bold: true,
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 20,
                }),
              ],
              shading: { fill: '#d7e0ed' },
            }),
            HeaderCell({
              children: [
                new TextRun({
                  text: '比率',
                  bold: true,
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 20,
                }),
              ],
              shading: { fill: '#d7e0ed' },
            }),
            HeaderCell({
              children: [
                new TextRun({
                  text: '人數',
                  bold: true,
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 20,
                }),
              ],
              shading: { fill: '#d7e0ed' },
            }),
            HeaderCell({
              children: [
                new TextRun({
                  text: '比率',
                  bold: true,
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 20,
                }),
              ],
              shading: { fill: '#d7e0ed' },
            }),
          ],
        }),
        // 第三行 - 數據行，顯示對應的數據
        ...formattedData,
      ],
    }),
    // new Paragraph(''),
    // new Paragraph({
    //   style: 'textParagraph',
    //   alignment: AlignmentType.RIGHT,
    //   children: [new TextRun({ text: '單位：人', font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' }, size: 24 })],
    // }),
  ]
}

export default Chapter4Sub2Page
